import * as Sentry from '@sentry/nextjs'
import { noop } from 'betterplace-utils'
import getAdditionalContext from './getAdditionalContext'
import { isRedirectError } from '@/helpers/errors'

function report(error: unknown, context?: Record<string, unknown>) {
  // do not report Next.js redirect errors
  if (isRedirectError(error)) return
  void getAdditionalContext()
    .then((additionalContext) => {
       
      Sentry.captureException(error, { ...additionalContext, extra: context })
    })
    .catch(noop)
}
export default report
